import React, { createContext, useState, useContext, useEffect } from "react";

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    return {
      language: "en",
      toggleLanguage: () => {},
      t: (key) => key,
    };
  }
  return context;
};

// Translations
const translations = {
  en: {
    // Navigation
    "nav.home": "Home",
    "nav.education": "Education",
    "nav.experience": "Experience",
    "nav.projects": "Projects",
    "nav.openSource": "Open Source",
    "nav.contact": "Contact",

    // Stats
    "stats.projects": "Projects",
    "stats.experience": "Years Experience",
    "stats.commits": "Commits",
    "stats.technologies": "Technologies",

    // Contact Form
    "contact.title": "Send a Message",
    "contact.name": "Your Name",
    "contact.email": "Your Email",
    "contact.subject": "Subject",
    "contact.message": "Your Message",
    "contact.send": "Send Message",
    "contact.sending": "Sending...",
    "contact.success": "Message sent successfully!",
    "contact.error": "Error sending message. Try again.",

    // 404
    "error.title": "404",
    "error.subtitle": "Page Not Found",
    "error.description":
      "The page you're looking for doesn't exist or has been moved.",
    "error.home": "Go Home",

    // Greeting
    greeting: "Hi, I'm",
    subtitle: "CEO of Arion AI. Passionate Web & Android Developer.",

    // Footer
    madeWith: "Made with",
    by: "by",
  },
  ru: {
    // Navigation
    "nav.home": "Главная",
    "nav.education": "Образование",
    "nav.experience": "Опыт",
    "nav.projects": "Проекты",
    "nav.openSource": "Open Source",
    "nav.contact": "Контакты",

    // Stats
    "stats.projects": "Проектов",
    "stats.experience": "Лет опыта",
    "stats.commits": "Коммитов",
    "stats.technologies": "Технологий",

    // Contact Form
    "contact.title": "Отправить сообщение",
    "contact.name": "Ваше имя",
    "contact.email": "Ваш Email",
    "contact.subject": "Тема",
    "contact.message": "Ваше сообщение",
    "contact.send": "Отправить",
    "contact.sending": "Отправка...",
    "contact.success": "Сообщение отправлено!",
    "contact.error": "Ошибка отправки. Попробуйте снова.",

    // 404
    "error.title": "404",
    "error.subtitle": "Страница не найдена",
    "error.description":
      "Страница, которую вы ищете, не существует или была перемещена.",
    "error.home": "На главную",

    // Greeting
    greeting: "Привет, я",
    subtitle: "CEO Arion AI. Увлечённый Web & Android разработчик.",

    // Footer
    madeWith: "Сделано с",
    by: "автор",
  },
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    const saved = localStorage.getItem("null7x-language");
    return saved || "en";
  });

  useEffect(() => {
    localStorage.setItem("null7x-language", language);
  }, [language]);

  const toggleLanguage = () => {
    setLanguage(language === "en" ? "ru" : "en");
  };

  const t = (key) => {
    return translations[language][key] || key;
  };

  return (
    <LanguageContext.Provider value={{ language, toggleLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};
